/**
 * Convert string into capital case.
 * First letters will be uppercase.
 * @memberof module:stringcase/lib
 * @function capitalcase
 * @param {string} str - String to convert.
 * @returns {string} Capital case string.
 */
'use strict';

var uppercase = require('./uppercase');
/** @lends capitalcase */


function capitalcase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return uppercase(str[0]) + str.slice(1);
}

module.exports = capitalcase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhcGl0YWxjYXNlLmpzIl0sIm5hbWVzIjpbInVwcGVyY2FzZSIsInJlcXVpcmUiLCJjYXBpdGFsY2FzZSIsInN0ciIsIlN0cmluZyIsInNsaWNlIiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7O0FBU0E7O0FBRUEsSUFBTUEsU0FBUyxHQUFHQyxPQUFPLENBQUMsYUFBRCxDQUF6QjtBQUVBOzs7QUFDQSxTQUFTQyxXQUFULENBQXNCQyxHQUF0QixFQUEyQjtBQUN6QkEsRUFBQUEsR0FBRyxHQUFHQyxNQUFNLENBQUNELEdBQUQsQ0FBWjs7QUFDQSxNQUFJLENBQUNBLEdBQUwsRUFBVTtBQUNSLFdBQU9BLEdBQVA7QUFDRDs7QUFDRCxTQUFPSCxTQUFTLENBQUNHLEdBQUcsQ0FBRSxDQUFGLENBQUosQ0FBVCxHQUFzQkEsR0FBRyxDQUFDRSxLQUFKLENBQVUsQ0FBVixDQUE3QjtBQUNEOztBQUVEQyxNQUFNLENBQUNDLE9BQVAsR0FBaUJMLFdBQWpCIiwic291cmNlUm9vdCI6Ii4uLy4uL2xpYiIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29udmVydCBzdHJpbmcgaW50byBjYXBpdGFsIGNhc2UuXG4gKiBGaXJzdCBsZXR0ZXJzIHdpbGwgYmUgdXBwZXJjYXNlLlxuICogQG1lbWJlcm9mIG1vZHVsZTpzdHJpbmdjYXNlL2xpYlxuICogQGZ1bmN0aW9uIGNhcGl0YWxjYXNlXG4gKiBAcGFyYW0ge3N0cmluZ30gc3RyIC0gU3RyaW5nIHRvIGNvbnZlcnQuXG4gKiBAcmV0dXJucyB7c3RyaW5nfSBDYXBpdGFsIGNhc2Ugc3RyaW5nLlxuICovXG5cbid1c2Ugc3RyaWN0J1xuXG5jb25zdCB1cHBlcmNhc2UgPSByZXF1aXJlKCcuL3VwcGVyY2FzZScpXG5cbi8qKiBAbGVuZHMgY2FwaXRhbGNhc2UgKi9cbmZ1bmN0aW9uIGNhcGl0YWxjYXNlIChzdHIpIHtcbiAgc3RyID0gU3RyaW5nKHN0cilcbiAgaWYgKCFzdHIpIHtcbiAgICByZXR1cm4gc3RyXG4gIH1cbiAgcmV0dXJuIHVwcGVyY2FzZShzdHJbIDAgXSkgKyBzdHIuc2xpY2UoMSlcbn1cblxubW9kdWxlLmV4cG9ydHMgPSBjYXBpdGFsY2FzZVxuIl19